<template>
  <div>
    <template v-if="row.bool_undo != 1">
      <div class="buttons d-flex-row align-items-center">
        <template v-if="!onlyMore">
          <el-button v-permission="'can_create_adv_order'" type="text" style="padding: 0 0" @click="copyOrder(row)"
                     v-if="opRange.indexOf('copy')>-1" size="mini"
          >复制
          </el-button>
        </template>
        <el-dropdown style="margin-left: 10px" trigger="click" @command="handleCommand($event,row)"
                     v-if="opRange.indexOf('more')>-1">
                  <span class="el-dropdown-link" style="font-size: 12px">
                    更多<i class="el-icon-arrow-down el-icon--right"></i>
                  </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item command="edit">
              {{ userAuth.can_update_adv_order_puke ? '编辑' : '查看' }}
            </el-dropdown-item>
<!--            <el-dropdown-item command="reverse"-->
<!--                              :disabled="!(userAuth.strike_balance_but_puke && (row.order_type === 'regular' ||row.order_type === '普通类型'))|| row.bool_exec === '未执行'  || (row.is_mark===1&&row.pid===0)">-->
<!--              冲账-->
<!--            </el-dropdown-item>-->
            <el-dropdown-item command="delete"
                              :disabled="!(userAuth.option_delete_adv_order_puke)">删除
            </el-dropdown-item>
            <el-dropdown-item command="cancel"
                              :disabled="!(userAuth.option_undo_adv_order_puke)">
              撤单
            </el-dropdown-item>
            <el-dropdown-item command="files"
                              :disabled="!(row.covenant_id)||!userAuth.can_see_covenant_files_puke">
              查看附件
            </el-dropdown-item>
<!--            <el-dropdown-item v-if="row.is_mark_invoiced==='Y'" command="un_mark_invoice"-->
<!--                              v-permission="'can_direct_invoice'">-->
<!--              取消发票标记-->
<!--            </el-dropdown-item>-->
<!--            <el-dropdown-item v-if="row.is_mark_rebate==='Y'" command="un_mark_rebate"-->
<!--                              v-permission="'can_order_mark_rebate'">-->
<!--              取消返点标记-->
<!--            </el-dropdown-item>-->
          </el-dropdown-menu>
        </el-dropdown>
      </div>
    </template>
    <template v-else>
      <div class="buttons d-flex-row align-items-center">
        <el-button type="text" @click="goView(row)" size="mini">查看</el-button>
        <el-button
            v-if="row.bool_undo == 1"
            type="text"
            size="mini"
            style="margin-left: 40px;"
            @click="goView(row)"
            disabled
        >已撤单
        </el-button>
      </div>
    </template>

    <exec-dialog :key="row.id" :visible.sync="dialogExecution" :order-id="row.id" @closed="callbackRefresh"/>
  </div>
</template>

<script>
// import {judgeOrderWholeCase} from "../index";
import {  markRebate} from "@/api/adOrder";
import {unDirectInvoice} from "@/api/bill";
import ExecDialog from "@/views/adOrder/components/ExecDialog.vue";
import {delectPukeOrder, undoPukeOrder} from "@/api/regulars";

export default {
  name: "AdPukeColumn",
  components: {ExecDialog},
  props: {
    row: {
      type: Object
    },
    rowIndex: {
      type: Number
    },
    opRange: {
      type: Array,
      default() {
        return ['exec', 'copy', 'more']
      }
    },
    onlyMore: {
      type: Boolean,
      default() {
        return false
      }
    },
    editRouteName: {
      type: String,
      default() {
        return 'editAdOrder'
      }
    },
    pt: Number,
  },
  data() {
    return {
      dialogExecution: false
    }
  },
  computed: {
    userAuth() {
      return this.$store.getters.getUserAuth;
    },
  },
  methods: {
    callbackRefresh() {
      this.$emit('refreshOrderList')
    },
    copyOrder(row) {
      // 复制订单
      const {href} = this.$router.resolve({
        name: `createAdOrder`,
        query: {type: "copy", source_id: row.id, pt: this.pt}
      });
      window.open(href, "_blank");
    },
    // 操作项
    handleCommand(command, row) {
      switch (command) {
        case 'edit': {
          // 编辑
          const {href} = this.$router.resolve({
            name: this.editRouteName,
            query: {pt: this.pt},
            params: {id: row.id},
          });
          window.open(href, "_blank");
          break;
        }
        case 'reverse': {
          // 冲账;
          if (row.bool_exec === '未执行' || row.bool_exec === 0) {
            this.$notify.warning('未执行的订单不可冲账，操作失败！');
            return false
          }
          if (judgeOrderWholeCase(row, 'main')) {
            this.$notify.warning('全案营销订单“主单”不能冲账，操作失败！');
            return false
          }
          const {href} = this.$router.resolve({
            name: `createAdOrder`,
            query: {type: "reverse", source_id: row.id, pt: this.pt}
          });
          window.open(href, "_blank");
          break;
        }
        case 'delete': {
          // 删除;
          this.orderDel([row])
          break;
        }
        case 'cancel': {
          // 取消;
          this.orderUndo(row)
          break;
        }
        case 'files':
          // 查看附件;
          this.handelPreviewFiles(row)
          break;
        case 'un_mark_invoice':
          this.handelUnMarkInvoice(row)
          break;
        case 'un_mark_rebate':
          this.handelUnMarkRebate(row)
          break;
        case 'child': {
          // 添加子订单;
          if (!judgeOrderWholeCase(row)) {
            this.$notify.warning('全案营销订单才能添加子订单');
            return false
          }
          if (row.pid !== 0) {
            this.$notify.warning('子单不能再添加子订单，操作失败！');
            return false
          }

          const {href} = this.$router.resolve({
            name: `createAdOrder`,
            query: {type: "child", source_id: row.id, pt: this.pt}
          });
          window.open(href, "_blank");
          break;
        }
        default: {
          // 默认;
          break;
        }
      }
    },
    handelPreviewFiles(obj) {
      const {href} = this.$router.resolve({
        name: `FilesPreview`,
        query: {
          covenant_id: obj.covenant_id,
        }
      });
      window.open(href, "_blank");
    },
    async handelUnMarkInvoice({order_no}) {
      const that = this
      const response = await unDirectInvoice({order_no})
      if (!response.success) {
        that.$notify.warning({title: '提示', message: response.message});
        return false
      }
      that.showToast({
        h: that,
        icon: "el-icon-success",
        text: "操作成功",
        duration: 2000
      });
      setTimeout(() => {
        that.$emit('refreshOrderList')
      }, 2000)
    },
    async handelUnMarkRebate({order_no}) {
      const that = this
      const response = await markRebate({order_nos: [order_no], mark: 'N'})
      if (!response.success) {
        that.$notify.warning({title: '提示', message: response.message});
        return false
      }
      that.showToast({
        h: that,
        icon: "el-icon-success",
        text: "操作成功",
        duration: 2000
      });
      setTimeout(() => {
        that.$emit('refreshOrderList')
      }, 2000)
    },
    orderUndo(row) {
      let msg = `订单编号：${row.order_no} 客户：${row.customer_name} 建单人：${row.creator || row.creator_name} 建单时间：${row.created_at} 执行状态：${row.bool_exec == 1 ? '已执行' : '未执行'}`
      let that = this;
      this.showModal({
        h: this,
        text: msg + "，确定撤单吗？",
        confirmText: "",
        cancelText: "",
        confirm: async function () {
          const response = await undoPukeOrder({id: row.id});
          if (!response.success) {
            that.$notify.warning({title: '提示', message: response.message});
            return false
          }
          that.showToast({
            h: that,
            icon: "el-icon-success",
            text: "撤单成功",
            duration: 2000
          });
          setTimeout(() => {
            that.$emit('refreshOrderList')
          }, 2000)
        }
      });
    },
    orderDel(list) {
      let that = this;
      this.showModal({
        h: this,
        text: "确定删除吗",
        confirmText: "",
        cancelText: "",
        confirm: async function () {
          let ids = list.map(_ => {
            return _.id
          });
          const response = await delectPukeOrder({id: ids[0]});
          if (!response.success) {
            that.$notify.warning({title: '提示', message: response.message});
            return false
          }
          that.showToast({
            h: that,
            icon: "el-icon-success",
            text: "删除成功",
            duration: 2000
          });
          setTimeout(() => {
            that.$emit('refreshOrderList')
          }, 2000)
        }
      });
    },
    goView(row) {
      this.editPage(row.id)
    },
    goDetail(row) {
      this.editPage(row.id)
    },
    editPage(id) {
      const {href} = this.$router.resolve({
        name: this.editRouteName,
        params: { id: id, isPreExecutor: 1, pt: this.pt },
      });
      window.open(href, "_blank");
    },
  }
}
</script>

<style scoped>

</style>
